module.exports = __webpack_public_path__ + "static/media/js.9bb05718.png";